import { createSelector } from 'reselect';
import { RootState } from 'store/types';

/**
 * Download Imaging Results
 */
export const imagingDetailsDownloadsSelector = (state: RootState) =>
  state.testResults.downloadImagingDetails;

export const imagingDetailsDownloadingSelector = createSelector(
  imagingDetailsDownloadsSelector,
  testResults => testResults.isDownloadingImagingDetails
);

export const imagingDetailsDownloadDataSelector = createSelector(
  imagingDetailsDownloadsSelector,
  testResults => testResults.data
);

/**
 * Share Imaging Results
 */
export const shareImagingResultsSelector = (state: RootState) =>
  state.testResults.shareImagingResults;

export const shareImagingResultsDataSelector = createSelector(
  shareImagingResultsSelector,
  shareImagingResults => shareImagingResults.sharedImagingResultsData
);

export const shareImagingResultsSendingSelector = createSelector(
  shareImagingResultsSelector,
  shareImagingResults => shareImagingResults.isSendingImagingResults
);
